/*eslint-disable*/
import React from 'react'
import { withFormik, Form as Fomiker, Field as Fieldmik } from 'formik'
import { Form as FormUi, Segment, Container, Button } from 'semantic-ui-react'
import { MyNormalInput, MyTextArea } from '../../apiInputComponent/myInput'
import AddTitleBar from '../../titleBar/add_titleBar'
import * as yup from 'yup';
import MyCategory from '../../apiInputComponent/myCategory'
import CreateAxios from '../../axiosComponent/create'
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import cogoToast from 'cogo-toast';


const AddServices = ({ values, errors, touched }) => {
    return (
        <>
            <AddTitleBar Title="New Service" LinkName="/service" />
            <Container fluid className="m-2">
                <Fomiker>
                    <Segment>
                        <div className="ui form tiny">
                            <FormUi.Group >
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">Service Name *</label>
                                </FormUi.Field>
                                <FormUi.Field error={values.psDescription ? false : true} width={3}>
                                    <Fieldmik component={MyNormalInput} name="psDescription" />
                                    {touched.psDescription && errors.psDescription ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.psDescription}</strong> : ''}
                                </FormUi.Field>
                                <FormUi.Field width={2} />
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">Service Code *</label>
                                </FormUi.Field>
                                <FormUi.Field error={values.psCode ? false : true} width={3}>
                                    <Fieldmik component={MyNormalInput} name="psCode" />
                                    {touched.psCode && errors.psCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.psCode}</strong> : ''}
                                </FormUi.Field>
                            </FormUi.Group>
                            <FormUi.Group >
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">Category *</label>
                                </FormUi.Field>
                                <FormUi.Field error={values.categoryId ? false : true} width={3}>
                                    <Fieldmik component={MyCategory} style={{ width: '100%' }} name="categoryId" />
                                    {touched.categoryId && errors.categoryId ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.categoryId}</strong> : ''}
                                </FormUi.Field>
                                <FormUi.Field width={2} />
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">Service Price (INR) *</label>
                                </FormUi.Field>
                                <FormUi.Field error={values.sellingPrice ? false : true} width={3}>
                                    <Fieldmik component={MyNormalInput} min="0" type="number" name="sellingPrice" />
                                    {touched.sellingPrice && errors.sellingPrice ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.sellingPrice}</strong> : ''}
                                </FormUi.Field>
                            </FormUi.Group>
                            <FormUi.Group >
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">GST %</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} min="0" type="number" name="gstPercentage" />
                                </FormUi.Field>
                                {touched.gstPercentage && errors.gstPercentage ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.gstPercentage}</strong> : ''}

                                <FormUi.Field width={2} />
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">TDS %</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} min="0" type="number" name="tdsTaxSectionId" />
                                </FormUi.Field>
                                {touched.tdsPercentageId && errors.tdsPercentageId ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tdsPercentageId}</strong> : ''}

                            </FormUi.Group>
                            <FormUi.Group >
                                <FormUi.Field width={3}>
                                    <label className="labelName p-bold-500 mt-2">Description</label>
                                </FormUi.Field>
                                <FormUi.Field>
                                    <Fieldmik rows={3} style={{ resize: 'none' }} component={MyTextArea} name="sellingDesc" />
                                </FormUi.Field>
                            </FormUi.Group>
                        </div>
                    </Segment>
                    <center><Button size="mini" primary type="submit">Submit</Button></center>
                </Fomiker>
            </Container>
        </>
    )
}

const FormikAddServices = withFormik({
    mapPropsToValues({ psDescription, psCode, categoryId, sellingPrice, gstPercentage, tdsPercentageId, sellingDesc, }) {
        return {
            psDescription: psDescription || '',
            psCode: psCode || '',
            categoryId: categoryId || '',
            sellingPrice: sellingPrice || '',
            gstPercentage: gstPercentage || '',
            tdsTaxSectionId: tdsPercentageId || '',
            sellingDesc: sellingDesc || '',
            psType: '2' || '',
            groupId: 0,
            // accountGroupId: 0,
        }
    },
    validationSchema: yup.object().shape({
        psDescription: yup.string().matches(/^[a-z\d\-_\s]+$/i, 'Special Characters not allowed').min(3, 'Must be more than 3 letters').required('Service Name is Required'),
        psCode: yup.string().min(3, 'Must be more than 3 letters').required('Service Code is Required'),
        categoryId: yup.string().required('Category is Required').required('Category is Required'),
        gstPercentage: yup.string().matches(/^\d{1,2}(\.\d{1,2})?$/, 'Ex. 12.23').optional(),
        tdsTaxSectionId: yup.string().matches(/^\d{1,2}(\.\d{1,2})?$/, 'Ex. 12.23').optional(),
        // sellingPrice: yup.string().matches(/^[0-9]+$/, 'Invalid Amount').required('Service Price is Required'),
        sellingDesc: yup.string().min(3, 'Must be more than 3 letters').optional(),
    }),
    handleSubmit(values, { setSubmitting }) {
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        let combine = {
            ...values,
            customerNumber: customerNo,
            userId: userId
        }

        Axios.put(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?userId=${userId}&customerNumber=${customerNo}`, combine, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            if(response?.data?.status === 200) {
                cogoToast.success(response.data?.message?.message)
                setTimeout(() => {
                    window.location.href = '/service'
                }, 500);
            } else {
                cogoToast.error(typeof response.data?.message == 'string' ? response.data?.message : response.data?.message?.message)
            }
            
        }))
        .catch(error => {
            cogoToast.error(response.data.message)
            console.log(error)})
    }
})(AddServices)

export default FormikAddServices